import { render, staticRenderFns } from "./bars.vue?vue&type=template&id=5f201db3"
import script from "./bars.vue?vue&type=script&lang=js"
export * from "./bars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports